import React, { useState } from 'react';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';

/**
 * Admin Page
 * Admin UI mockup with login and dashboard
 * Note: This page is not included in main navigation (Task 11.8)
 */
const Admin = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  return (
    <>
      {!isLoggedIn ? (
        <AdminLogin onLoginSuccess={handleLoginSuccess} />
      ) : (
        <AdminDashboard />
      )}
    </>
  );
};

export default Admin;
